import { Box } from '@ff-it/ui';
import { TitleContainer } from 'components/TitleContainer';
import { PaymentStateBadge } from './PaymentStateBadge';
import type { ListIncome } from '../income/types';
import type { ListExpense } from '../expenses/types';
import { formatDate, sepFormat } from 'utilities';

export const numberColumnWidth = 160;

export const totalsColumn = {
  content: <TitleContainer title="Total" subtitle="Sub total" />,
  configLabel: 'Total / Sub Total',
  key: 'total',
  render: ({ total, sub_total }: ListIncome | ListExpense) => (
    <TitleContainer title={sepFormat(total)} subtitle={sepFormat(sub_total)} />
  ),
  width: 110,
  cellProps: { className: 'text-right py-0' },
  sortable: true,
} as const;

export const checkoutDateColumn = {
  key: 'checkout_date',
  configLabel: 'Checkout date',
  cellProps: { className: 'text-left py-0' },
  sortable: true,
  width: 120,
  content: 'Date',
  render: ({ checkout_date }: ListIncome | ListExpense) => formatDate(checkout_date),
} as const;

export const paymentDateColumn = {
  key: 'payment_date',
  cellProps: { className: 'text-left py-0' },
  sortable: true,
  width: 120,
  content: 'Payment',
  render: ({ payment_date, sums }: ListIncome | ListExpense) => (
    <Box display="flex" alignItems="center" gap="1">
      {formatDate(payment_date)}
      <PaymentStateBadge state={sums.paym_state} />
    </Box>
  ),
} as const;
